export function onlyNumber(
  value: string,
  min: number = 0,
  max: number = Infinity,
  allowDecimal: boolean = false
) {
  if (!value) return value;

  let cleaned: string;

  if (allowDecimal) {
    // allow digits and at most one dot
    cleaned = value.replace(/[^0-9.]/g, "");

    // prevent multiple dots
    const parts = cleaned.split(".");
    cleaned =
      parts.length > 2 ? parts[0] + "." + parts.slice(1).join("") : cleaned;
  } else {
    // old behavior: only digits
    cleaned = value.replace(/[^\d]/g, "");
  }

  const number = parseFloat(cleaned);

  if (isNaN(number)) return "";

  if (number < min) return `${min}`;
  if (number > max) return `${max}`;

  return cleaned;
}


export function onlyMobileNumber(value: string) {
  if (!value) return value;
  return value.replace(/[^\d]/g, "").slice(0, 10);
}

export function onlyAlphaNumeric(data: string) {
  if (!data) return data;
  return data.replace(/[^a-zA-Z0-9]/g, "");
}

export function maxLength(value: string, max = 10) {
  if (!value) {
    return value;
  }
  if (value.length > max) {
    return value.slice(0, max);
  }
  return value;
}
